import { useContext } from "react"
import { UserContext } from "@context"
import { Tooltip } from "@heroui/react"

import {
  BuildingOffice2Icon,
  BookmarkSlashIcon,
  ClockIcon,
  PhoneArrowDownLeftIcon,
  VideoCameraIcon,
  QueueListIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/24/outline"

import PropTypes from "prop-types"

const EventIconSummary = ({ 
  classNames = "text-indigo-800 dark:text-content2-foreground", 
  iconClassNames = "",
  isPhone, 
  isVc, 
  isVcTimer, 
  isVenue, 
  isOpenToParents, 
  isOpenToStaff, 
  isParentBookingsDisabled,
  size = "md" 
}) => {
  const { user } = useContext(UserContext)
  
  const iconSize = size === "sm" ? "h-5" : size === "md" ? "h-7" : "h-9"

  return (
    <div className={`flex ${classNames}`}>
      <Tooltip showArrow={true} color="secondary" content="Venue event" className="capitalize">
        <BuildingOffice2Icon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!isVenue && "opacity-20"}`} />
      </Tooltip>

      <Tooltip showArrow={true} color="secondary" content="Phone event" className="capitalize">
        <PhoneArrowDownLeftIcon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!isPhone && "opacity-20"}`} />
      </Tooltip>

      <Tooltip showArrow={true} color="secondary" content="Video conference event" className="capitalize">
        <VideoCameraIcon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!isVc && "opacity-20"}`} />
      </Tooltip>

      <Tooltip showArrow={true} color="secondary" content="VC Timer" className="capitalize">
        <ClockIcon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!isVcTimer && "opacity-20"}`} />
      </Tooltip>

      <Tooltip showArrow={true} color="secondary" content="Open to parents" className="capitalize">
        <UserGroupIcon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!isOpenToParents && "opacity-20"}`} />
      </Tooltip>

      <Tooltip showArrow={true} color="secondary" content="Open to staff" className="capitalize">
        <UsersIcon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!isOpenToStaff && "opacity-20"}`} />
      </Tooltip>

      <Tooltip showArrow={true} color="secondary" content="Bookings disabled" className="capitalize">
        <BookmarkSlashIcon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!isParentBookingsDisabled && "opacity-20"}`} />
      </Tooltip>

      <Tooltip showArrow={true} color="secondary" content="Waiting list" className="capitalize">
        <QueueListIcon className={`mr-3 ${iconSize} w-auto ${iconClassNames} ${!user?.me?.client?.settings?.allow_parent_waiting_list && "opacity-20"}`} />
      </Tooltip>
    </div>
  )
}

EventIconSummary.propTypes = {
  classNames: PropTypes.string,
  iconClassNames: PropTypes.string,
  isParentBookingsDisabled: PropTypes.bool.isRequired,
  isPhone: PropTypes.bool.isRequired,
  isVc: PropTypes.bool.isRequired,
  isVenue: PropTypes.bool.isRequired,
  isVcTimer: PropTypes.bool.isRequired,
  isOpenToParents: PropTypes.bool.isRequired,
  isOpenToStaff: PropTypes.bool.isRequired,
  size: PropTypes.string,
}

export default EventIconSummary
